// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import { withRouter } from 'react-router-dom'
import { Query } from 'react-apollo'

import {
  Card,
  EmployeeStats,
  Grid,
  Spinner,
  Warning
} from '../../components'

import { decodeBase64 } from '../../utils'

import { QUERY_EMPLOYER_DIVISIONS } from '../../queries'


const EmployeeOverview = (props) => {
  const employerId = props.match.params.employerId

  return (
    <div
      className='slds-grid slds-size_1-of-1'
      style={{
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: 'calc(100vh - 80px)'
      }}>
      <div className='slds-size_1-of-2 slds-m-top_xx-large'>
        <Card
          title={
            <div className='slds-text-color_weak' style={{ textAlign: 'center' }}>
              Overview
            </div>
          }
          body={
            <EmployeeStats
              employerId={employerId}
              className='slds-p-bottom_medium'
            />
          }
          style={{
            borderRadius: '5px',
            border: '1px solid rgba(90, 86, 251, 0.25)',
            boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.35)'
          }}
        />
      </div>
      <div className='slds-size_1-of-1 slds-m-top_large u-font-size-smaller'>
        <Query
          query={QUERY_EMPLOYER_DIVISIONS}
          variables={{ employerId: decodeBase64(employerId) }}>
          {({ loading, error, data }) => {
            if (loading) {
              return <Spinner size='small' className='slds-is-relative' />
            }

            if (error) {
              return <Warning>Failed to fetch required division data</Warning>
            }

            if (data.divisions.edges.length > 1) {
              return (
                <Grid
                  items={data.divisions.edges.map(({ node: division }) => (
                    <Card
                      title={
                        <div className='slds-text-color_weak u-font-size-smaller' style={{ textAlign: 'center' }}>
                          {division.name}
                        </div>
                      }
                      body={
                        <EmployeeStats
                          employerId={employerId}
                          divisionId={division.id}
                          className='slds-p-bottom_medium'
                          key={`employer_stats_${employerId}`}
                        />
                      }
                      style={{
                        borderRadius: '5px',
                        border: '1px solid rgba(90, 86, 251, 0.25)',
                        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.35)'
                      }}
                      key={`subsidiary_${employerId}`}
                    />
                  ))}
                  evenlySpaceOutColumns={true}
                  itemSpacing='medium'
                  itemClassName='slds-p-left_small slds-p-right_small slds-p-bottom_large'
                  className='slds-p-left_small slds-p-right_small'
                />
              )
            }
            else {
              return null
            }
          }}
        </Query>
      </div>
    </div>
  )
}

export default withRouter(EmployeeOverview)



// WEBPACK FOOTER //
// ./src/containers/messageplus/EmployeeOverview.js